//Production
export const baseUrl =
  process.env.REACT_APP_FRONTEND_BASEURL ?? "https://courier-app.appantech.com";
export const baseAuthUrl =
  process.env.REACT_APP_FRONTEND_BASEURL ?? "https://courier-app.appantech.com";

// export const baseUrl =
//   process.env.REACT_APP_FRONTEND_BASEURL ?? "http://localhost:3101";
// export const baseAuthUrl =
//   process.env.REACT_APP_FRONTEND_BASEURL ?? "http://localhost:3100";
export const AES_SECRET =
  process.env.REACT_APP_AES_SECRET_VALUE ?? "k9mZqP7xT2rYwJ8v";

console.log(
  "::ENV Value::",
  process.env.REACT_APP_FRONTEND_BASEURL,
  process.env.REACT_APP_AES_SECRET_VALUE,
);

export const apiList = {
  LOGIN_OTP: baseAuthUrl + "/sms/login",
  LOGIN: baseAuthUrl + "/sms/login-validate",
  LOGOUT: baseUrl + "/master/user/logout",
  FORGOTPWD: baseAuthUrl + "/sms/forgotPassword",
  VALIDATE_OTP: baseAuthUrl + "/sms/valotp",
  UPDATE_PASSWORD: baseAuthUrl + "/sms/updatePassword",
  RESET_USERNAME: baseAuthUrl + "/sms/send-otp",
  VERIFY_OTP_LOGOUT: baseAuthUrl + "/sms/verify-otp-logout",
  PINCODE_DATA: baseAuthUrl + "/sms/pincode",

  //GLOBAL API
  FETCH_COURIER_ACC_DETAILS: baseUrl + "/master/appantech-accDt/fetch",
  ALL_ACTIVE_CUSTOMER_DATA: baseUrl + "/master/customer/allData", // All Active Customer Data
  FETCH_ALL_MASTER_LMBP_LIST: baseUrl + "/master/customer/masterLmbps", // All Active Master Lmbp

  // Retailer Master
  FETCH_CUSTOMER_DATA: baseUrl + "/master/customer/fetch",
  CREATE_CUSTOMER_DATA: baseUrl + "/master/customer/create",
  MODIFY_CUSTOMER_DATA: baseUrl + "/master/customer/modify",
  DELETE_CUSTOMER_DATA: baseUrl + "/master/customer/authorblock",
  AUTH_CUSTOMER_DATA: baseUrl + "/master/customer/authorblock",
  CUST_AUDIT_DATA: baseUrl + "/master/customer/auditData",
  SEND_CREDENTIALS: baseUrl + "/master/customer/sendCredentials",

  FETCH_RETAILER_DATA: baseUrl + "/master/retailer/fetch",
  ALL_ACTIVE_RETAILER_DATA: baseUrl + "/master/retailer/allData",
  CREATE_RETAILER_DATA: baseUrl + "/master/retailer/create",
  MODIFY_RETAILER_DATA: baseUrl + "/master/retailer/modify",
  DELETE_RETAILER_DATA: baseUrl + "/master/retailer/authorblock",
  AUTH_RETAILER_DATA: baseUrl + "/master/retailer/authorblock",

  FETCH_VENDOR_DATA: baseUrl + "/master/vendor/fetch",
  ALL_ACTIVE_VENDOR_DATA: baseUrl + "/master/vendor/allData",
  CREATE_VENDOR_DATA: baseUrl + "/master/vendor/create",
  MODIFY_VENDOR_DATA: baseUrl + "/master/vendor/modify",
  DELETE_VENDOR_DATA: baseUrl + "/master/vendor/authorblock",
  AUTH_VENDOR_DATA: baseUrl + "/master/vendor/authorblock",
  VENDOR_AUDIT_DATA: baseUrl + "/master/vendor/auditData",

  FETCH_USER_DATA: baseUrl + "/master/user/fetch",
  CREATE_USER_DATA: baseUrl + "/master/user/create",
  MODIFY_USER_DATA: baseUrl + "/master/user/modify",
  DELETE_USER_DATA: baseUrl + "/master/user/authorblock",
  UNBLOCK_USER: baseUrl + "/master/user/unblock",
  AUTH_USER_DATA: baseUrl + "/master/user/authorblock",
  USER_AUDIT_DATA: baseUrl + "/master/user/auditData",

  FETCH_BUYSMS_DATA: baseUrl + "/master/txn/fetchBuyTransactions",
  CREATE_BUYSMS_DATA: baseUrl + "/master/txn/buysms",
  CREATE_RCSSMS_DATA: baseUrl + "/master/txn/buyrcs",

  FETCH_SELLSMS_DATA: baseUrl + "/master/txn/fetchSaleTransactions",
  CREATE_SELLSMS_DATA: baseUrl + "/master/txn/salesms",

  OVER_ALL_PROGRESS: "/master/txn/overallProgress",
  OVERVIEW_SMS: "/master/txn/overview",
  SUMMARY_SMS: "/master/txn/summary",

  DASHBOARD_DATA: "/master/txn/dashboard",
  ORDER_FILTER_OPTIONS: "/master/txn/orderFilterOptions", // Hub / LMBP / sub-LMBP / user filters

  UPDATE_USER_MENU: "/master/user/updateUserMenu",
  FETCH_USER_MENU: "/master/user/fetchUserMenu",

  SMS_TRANSACTION_HISTORY: "/master/txn/fetchCusTxnHistory",
  SMS_MASTER_DATA: baseUrl + "/master/txn/fetchSmsMaster",

  RCS_TRANSACTION_HISTORY: baseUrl + "/master/rcs/fetch",

  DLT_ADD_ENTITY: baseUrl + "/master/dlt/addentity",
  DLT_FETCH_ENTITY: baseUrl + "/master/dlt/fetchentity",
  DLT_ADD_SENDER: baseUrl + "/master/dlt/addsendorid",
  DLT_FETCH_SENDER: baseUrl + "/master/dlt/fetchsendorid",
  DLT_ADD_TEMPLATE: baseUrl + "/master/dlt/addtemplate",
  DLT_FETCH_TEMPLATE: baseUrl + "/master/dlt/fetchtemplate",

  FETCH_ROLE_DATA: baseUrl + "/master/role/fetch",
  CREATE_ROLE_DATA: baseUrl + "/master/role/create",
  MODIFY_ROLE_DATA: baseUrl + "/master/role/modify",
  DELETE_ROLE_DATA: baseUrl + "/master/role/authorblock",
  AUTH_ROLE_DATA: baseUrl + "/master/role/authorblock",

  MENU_USERROLE_DATA: baseUrl + "/master/role/fetchuserrole",
  MENU_FETCH_ROLE_MENU: baseUrl + "/master/role/fetchmenu",

  FETCH_TOPUP_REQ: baseUrl + "/master/txn/fetchwalletload",
  CREATE_TOPUP_REQ: baseUrl + "/master/txn/createwalletload",
  CREATE_SMSTOPUPREQUEST: baseUrl + "/master/txn/smsTopupRequest",
  CREATE_TOPUP_WALLET: baseUrl + "/master/txn/mainWalletTopupRequest",
  MODIFY_WALLET_TOPUP_REQUEST: baseUrl + "/master/txn/modifyWalletTopupRequest",
  CREATE_TOPUP_RCS: baseUrl + "/master/txn/rcsTopupRequest",
  AUTH_TOPUP_REQ: baseUrl + "/master/txn/authorblockwalletload",

  MODIFY_DATA: baseUrl + "/master/dlt/modifyentityid",
  MODIFY_SENDER: baseUrl + "/master/dlt/modifysendorid",
  MODIFY_TEMPLATE: baseUrl + "/master/dlt/modifytemplate",

  DELETE_SENDORID: baseUrl + "/master/dlt/deletesendorid",
  DELETE_TEMPLATEID: baseUrl + "/master/dlt/deletetemplate",

  AUTH_BLOCK_TOPUP_REQ: baseUrl + "/master/txn/authorblockwalletload",
  CHECK_TOPUP_REQ: baseUrl + "/master/txn/checkwalletload",

  FETCH_RCS_AGENT: baseUrl + "/master/customer/FetchRcsAgent",
  MODIFY_RCS_AGENT: baseUrl + "/master/customer/modifyRcsAgent",

  // Bulk Message
  BULK_UPLOAD: baseUrl + "/master/bulk/upload",
  BULK_SENDER_ID: baseUrl + "/master/bulk/fetchSendersId",
  FETCH_ENTITY_TEMPLATE_ID: baseUrl + "/master/bulk/fetchEntityTemplate",
  FETCH_BULK_REPORT_DATA: baseUrl + "/master/bulk/fetch",
  FETCH_BY_FILE_PATH: baseUrl + "/master/bulk/fetchByFilePath",

  // Recharge
  RECHARGE: baseUrl + "/master/recharge/mobile/create",
  DTH: baseUrl + "/master/recharge/dth/create",
  FETCH_OPERATOR_CODES: baseUrl + "/master/recharge/OperatorCodesFetch",

  //Main Wallet Activity
  Fetch_CusWallet_History: baseUrl + "/master/txn/fetchCusWalletHistory",

  // Top Up Main Wallet
  FETCH_MAIN_WALLET_HISTORY: baseUrl + "/master/txn/fetchMainWalletload",
  EMAIL_STATUS: baseUrl + "/master/email/status", // Mail status for an account (Operation)
  EMAIL_RESEND_LAST: baseUrl + "/master/email/resendLast",
  MAIN_WALLET_DATE_SUMMARY: baseUrl + "/master/txn/mainWalletTopupDateSummary", // Date-wise recharge report
  AUTH_MAIN_WALLET_REQ: baseUrl + "/master/txn/authorblockmainwalletbalance",
  MAIN_WALLET_AUDIT_DATA: baseUrl + "/master/txn/auditDataMainWalletload",
  TOPUP_WALLET_SEND_OTP: baseUrl + "/master/txn/send-otp",
  TOPUP_WALLET_VERIFY_OTP: baseUrl + "/master/txn/verify-otp",

  //SMS History Download
  SMS_FULL_STATEMENT_HISTORY:
    baseUrl + "/master/txn/rquestDownloadSmsTxnHistory",
  SMS_DOWNLOAD_HISTORY: baseUrl + "/master/txn/downloadSmsTxnReportList",

  // RCS History Download
  RCS_FULL_STATEMENT_HISTORY: baseUrl + "/master/rcs/requestDownloadRcsLog",
  RCS_DOWNLOAD_HISTORY: baseUrl + "/master/rcs/downloadRcsReportList",
  RCS_DASHBOARD: baseUrl + "/master/rcs/rcs-dashboard",

  // Rate Check
  RATE_CHECK: baseUrl + "/master/rate/check",

  //Check GST No
  GET_GST_STATUS: baseUrl + "/master/customer/getGstStatus",
  GST_LOOKUP: baseUrl + "/master/customer/gstLookup", // GSTIN → PAN, state, duplicates (onboarding)
  GET_COMPANY_PAN_STATUS: baseUrl + "/master/customer/getCompanyPanStatus",

  //Get RCS ID
  GET_RCS_AGENT_ID: baseUrl + "/master/customer/getRcsAgentId",

  //Recharge
  FETCH_RECHARGE_DATA: baseUrl + "/master/recharge/fetch",
  TXN_REPORT_REQUEST_DOWNLOAD_HISTORY:
    baseUrl + "/master/recharge/requestDownloadBdTxnHistory",
  TXN_REPORT_DOWNLOAD_HISTORY:
    baseUrl + "/master/recharge/downloadBdTxnReportList",
  IP_WHITE_LISTING_CREATE: baseUrl + "/master/ipwhitelist/create",
  FETCH_IP_WHITE_LISTING: baseUrl + "/master/ipwhitelist/allData",

  //Courier Master
  FETCH_COURIER_MASTER_DATA: baseUrl + "/master/courier/fetch",
  CREATE_COURIER_MASTER: baseUrl + "/master/courier/create",
  MODIFY_COURIER_MASTER: baseUrl + "/master/courier/modify",
  AUTH_COURIER_MASTER_DATA: baseUrl + "/master/courier/authorblock",

  //Order Master
  FETCH_ORDER_MASTER_DATA: baseUrl + "/master/order/fetch",
  ORDER_MASTER_DOWNLOAD_HISTORY:
    baseUrl + "/master/order/requestDownloadOrderLog",
  ORDER_MASTER_DOWNLOAD_HISTORY_LIST:
    baseUrl + "/master/order/downloadOrderReportList",
  FETCH_ADDRESS_DETAILS: baseUrl + "/master/address/allData",
  SUBMIT_ORDER_TO_OEM: baseUrl + "/master/bag/submit-order",
  SUBMIT_ORDER_TO_DIRECT_DELHIVERY:
    baseUrl + "/master/bag/submit-direct-delhivery",
  OEM_RATE_CALCULATION: baseUrl + "/master/order/rate-calculation/fetch",
  ORDER_PINCODE_SERVICEABILITY:
    baseUrl + "/master/order/pincode-serviceability",
  RESEND_ORDER: baseUrl + "/master/bag/retry-submit-order",
  CANCEL_ORDER: baseUrl + "/master/order/cancel-order",
  CANCEL_SHYPME_ORDER: baseUrl + "/master/optn/cancel-order",
  CANCEL_DELHIVERY_ORDER: baseUrl + "/master/delhivery/cancel-order",
  UPDATE_WAY_BILLNUMBER: baseUrl + "/master/order/updateWaybill",
  SUBMIT_ORDER_TO_DIRECT_TRACKON: baseUrl + "/master/bag/submit-direct-trackon",
  TRACKON_RATE_CALCULATION: baseUrl + "/master/order/trackon/checkCharges",
  SUBMIT_ORDER_TO_DIRECT_SHREE_MARUTI:
    baseUrl + "/master/delcaper/submit-delcaper",
  SUBMIT_ORDER_TO_SHREE_TIRUPATI: baseUrl + "/master/bag/submit-stcs",

  // Print Label
  TRACKON_PRINT_LABEL: baseUrl + "/master/trackon/print-label",
  D_DELHIVERY_PRINT_LABEL: baseUrl + "/master/delhivery/print-label",
  SHREE_MARUTI_PRINT_LABEL: baseUrl + "/master/delcaper/print-label",

  //Ledger
  FETCH_LEDGER_MASTER_DATA: baseUrl + "/master/ledger/fetch",
  LEDGER_REPORT_DOWNLOAD_HISTORY:
    baseUrl + "/master/ledger/requestDownloadLedgerLog",
  LEDGER_REPORT_DOWNLOAD_HISTORY_LIST:
    baseUrl + "/master/ledger/downloadLedgerReportList",

  // Ledger Report
  FETCH_LEDGER_REPORT_DATA: baseUrl + "/master/ledger/fetch",
  FETCH_GENERAL_LEDGER_DATA: baseUrl + "/master/general-ledger/fetch",

  //RCS
  RCS_UPLOAD_MOBILE_EXCEL: baseUrl + "/master/rcs/uploadMobileExcel",

  // Vegaah
  FETCH_VEGAAH_REPORT_DATA: baseUrl + "/master/vegaah/fetch",
  VEGAAH_REPORT_UPLOAD: baseUrl + "/master/vegaah/upload-report",
  VEGAAH_REPORT_RECONCILE: baseUrl + "/master/vegaah/reconcile",
  VEGAAH_FETCH_PAYMENT_HISTORY: baseUrl + "/master/vegaah/fetch-payment",
  PAYMENT_REPORT_REQUEST: baseUrl + "/master/vegaah/request-payment-report",
  PAYMENT_REPORT_DOWNLOAD_HISTORY:
    baseUrl + "/master/vegaah/payment-report-list",
  VEGAAH_PAYMENT_GATEWAY_STATUS: baseUrl + "/master/vegaah/payment/status",

  //RCSStandaloneMsg
  CHECK_CAPABILITY: baseUrl + "/master/rcsproxy/checkCapability",
  SEND_RICH_CARD: baseUrl + "/master/rcsproxy/standalone/sendMsg",
  SEND_RICH_REPLY_CARD: baseUrl + "/master/rcsproxy/standalone/suggestedReply",
  SEND_RICH_CALENDAR_CARD:
    baseUrl + "/master/rcsproxy/standalone/suggestedCalenderEvent",
  SEND_RICH_LOCATION_CARD:
    baseUrl + "/master/rcsproxy/standalone/suggestedSharedLocation",
  SEND_RICH_DIALER_CARD:
    baseUrl + "/master/rcsproxy/standalone/suggestedDialerAction",
  SEND_RICH_OPEN_URL_CARD:
    baseUrl + "/master/rcsproxy/standalone/suggestedOpenURL",
  SEND_RICH_COMBINED_CARD:
    baseUrl + "/master/rcsproxy/standalone/withCombination",

  //RCSPlainText
  PLAIN_TEXT: baseUrl + "/master/rcsproxy/plaintext/sendPlainText",
  PLAIN_TEXT_CTA: baseUrl + "/master/rcsproxy/plaintext/sendCTA",
  PLAIN_TEXT_DIALER: baseUrl + "/master/rcsproxy/plaintext/sendDialer",
  PLAIN_TEXT_SUGGESTION: baseUrl + "/master/rcsproxy/plaintext/sendSuggestion",

  //RCS-Carousel
  SEND_CAROUSEL_MESSAGE:
    baseUrl + "/master/rcsproxy/carousel/sendCarouselBasic",
  SEND_CAROUSEL_ADVANCED:
    baseUrl + "/master/rcsproxy/carousel/sendCarouselAdvanced",

  //Update User Menu
  COMPANY_UPDATE_USER_MENU: baseUrl + "/master/company-details/updateUserMenu",

  //Courier Master
  CREATE_ORDER: baseUrl + "/master/order/create",
  MODIFY_ORDER: baseUrl + "/master/order/modify",
  CANCEL_SHIPMENT: baseUrl + "/master/courierproxy/cancelOrder",
  BARCODE_REQUEST: baseUrl + "/master/order/barcodeRequest",
  FETCH_GENERATE_STICKER: baseUrl + "/master/order/barcodeRequest/fetch",
  VALIDATE_BARCODE: baseUrl + "/master/order/barcode/validate",
  CHECK_CHARGES: baseUrl + "/master/order/checkCharges",

  // customer Enquiries
  FETCH_CUSTOMER_ENQUIRIES: baseUrl + "/master/website-form/fetch",
  FETCH_OTP_ENQUIRY: baseUrl + "/master/sms/otp-enquiry",
  CUSTOMER_ENQUIRIES_DOWNLOAD_HISTORY:
    baseUrl + "/master/scheduler/requestDownloadSchedulerLog",
  CUSTOMER_ENQUIRIES_DOWNLOAD_HISTORY_LIST:
    baseUrl + "/master/scheduler/downloadSchedulerReportList",

  //Admin Free TopUp
  CREATE_FREE_TOPUP_REQUEST: baseUrl + "/master/txn/adminFreeTopup",

  // Pickup Address
  FETCH_PICKUPADDRESS: baseUrl + "/master/address/fetch",
  CREATE_PICKUPADDRESS: baseUrl + "/master/address/create",
  MODIFY_PICKUPADDRESS: baseUrl + "/master/address/modify",

  // Bag Master
  CREATE_BAG: baseUrl + "/master/bag/create",
  FETCH_BAG_MASTER: baseUrl + "/master/bag/fetch",
  ADD_ITEMS_BAG_MASTER: baseUrl + "/master/bag/add-items",
  REMOVE_ITEMS_BAG_MASTER: baseUrl + "/master/bag/edit-items",
  BAG_SEAL: baseUrl + "/master/bag/seal",
  SEND_TO_HUB: baseUrl + "/master/bag/sendToHub",
  ACCEPT_BAG_BY_HUB: baseUrl + "/master/bag/acceptByHub",

  // Notification Master
  FETCH_NOTIFICATION_MASTER: baseUrl + "/master/notification/fetch",

  // Create Courier HUB
  CREATE_COURIER_HUB: baseUrl + "/master/courier-hub/create",
  MODIFY_COURIER_HUB: baseUrl + "/master/courier-hub/modify",
  FETCH_COURIER_HUB: baseUrl + "/master/courier-hub/fetch",
  AUTH_COURIER_HUB: baseUrl + "/master/courier-hub/authorblock",
  ALL_ACTIVE_HUB_DATA: baseUrl + "/master/courier-hub/allData",

  // Delivery Master
  CREATE_DELIVERY_BOY: baseUrl + "/master/deliverboy/create",
  FETCH_DELIVERY_BOY: baseUrl + "/master/deliverboy/fetch",
  MODIFY_DELIVERY_BOY: baseUrl + "/master/deliverboy/modify",
  FETCH_ALL_DELIVERY_BOY_DATA: baseUrl + "/master/deliverboy/allData",
  NOTIFICATION_SEND_OTP: baseUrl + "/master/bag/send-otp",
  NOTIFICATION_VERIFY_OTP: baseUrl + "/master/bag/verify-otp",
  ACCEPT_BY_HUB: baseUrl + "/master/bag/acceptByHub",
  GENERATE_DUAL_OTP_HUB: baseUrl + "/master/bag/generate-dual-otp",
  VERIFY_DUAL_OTP_HUB: baseUrl + "/master/bag/verify-dual-otp",
  HANDOVER_TO_DELIVERY_BOY: baseUrl + "/master/bag/handoverToDeliveryBoy",
  CONFIRM_HUB_ARRIVAL: baseUrl + "/master/bag/confirmHubArrival",
  OPEN_BAG: baseUrl + "/master/bag/open",

  // Rate Calculator
  RATE_CALCULATOR: baseUrl + "/master/optn/rate-calculator",
  PINCODE_SERVICEABILITY: baseUrl + "/master/optn/pincode-serviceability",
  PINCODE_LOOKUP: baseUrl + "/master/optn/pincode-details",
  PINCODE_ADD: baseUrl + "/master/optn/pincode-create",
  RATE_CALCULATION: baseUrl + "/master/optn/rate-calculator",
  DELHIVERY_RATE_CALCULATOR: baseUrl + "/master/delhivery/rate-calculator",
  SHREE_MARUTI_RATE_CALCULATOR: baseUrl + "/master/delcaper/rate-calculator",
  ALL_CARRIER_RATE_CALCULATOR: baseUrl + "/master/rate/checkAll",

  // Charges Master
  FETCH_CHARGES_MASTER: baseUrl + "/master/charges/fetch",
  CREATE_CHARGES_MASTER: baseUrl + "/master/charges/create",
  MODIFY_CHARGES_MASTER: baseUrl + "/master/charges/modify",
  FETCH_GET_ZONE: baseUrl + "/master/order/getZone",
  DELETE_CHARGES_MASTER: baseUrl + "/master/charges/delete",
  VALIDATE_BULK_CHARGE_MASTER: baseUrl + "/master/charges/bulk-validate",
  CREATE_BULK_CHARGE_MASTER: baseUrl + "/master/charges/bulk-create",

  //Shipment Tracking
  SHIPMENT_TRACKING: baseUrl + "/master/optn/shipment-tracking", // No Use
  SHIPMENT_TRACKING_DELHIVERY:
    baseUrl + "/master/optn/shipment-tracking-delhivery", // No Use
  SHIPMENT_TRACKING_TRACKON: baseUrl + "/master/optn/shipment-tracking-trackon", // No Use
  ALL_CARRIER_ORDER_TRACKING: "/master/track-order",

  // Franchise Master
  FETCH_FRANCHISE_MASTER: baseUrl + "/master/franchise/fetch",
  CREATE_FRANCHISE_MASTER: baseUrl + "/master/franchise/create",
  MODIFY_FRANCHISE_MASTER: baseUrl + "/master/franchise/modify",
  AUTH_FRANCHISE_MASTER: baseUrl + "/master/franchise/authorblock",
  GET_FRANCHISE_GST_STATUS: baseUrl + "/master/franchise/getGstStatus",
  GET_FRANCHISE_COMPANY_PAN_STATUS:
    baseUrl + "/master/franchise/getCompanyPanStatus",
  AUTH_FRANCHISE_DATA: baseUrl + "/master/franchise/authorblock",
  AUDIT_FRANCHISE_DATA: baseUrl + "/master/franchise/auditData",
  ALL_ACTIVE_FRANCHISE_DATA: baseUrl + "/master/franchise/allData",

  // Stationary Master
  FETCH_STATIONARY_MASTER: baseUrl + "/master/stationary/fetch",
  CREATE_STATIONARY_MASTER: baseUrl + "/master/stationary/create",
  MODIFY_STATIONARY_MASTER: baseUrl + "/master/stationary/modify",
  ADD_REMARK_BUY_STATIONARY: baseUrl + "/master/stationary/add-remark",
  UPDATE_STATIONARY_REMARK: baseUrl + "/master/stationary/add-remark",

  // Buy Stationary Master
  GET_STATIONARY_ITEMS_DETAILS: baseUrl + "/master/stationary/getAll",
  FETCH_BUY_STATIONARY_MASTER: baseUrl + "/master/stationary/fetch-request",
  CREATE_BUY_STATIONARY_MASTER: baseUrl + "/master/stationary/generate-request",
  MODIFY_BUY_STATIONARY_MASTER:
    baseUrl + "/master/stationary/update-status-request",

  // Payment Gateway
  CREATE_PAYMENT_GATEWAY: baseUrl + "/master/vegaah/payment/create",

  // Rate Card Master
  FETCH_RATE_CARD_MASTER: baseUrl + "/master/rate-card/fetch",
  CREATE_RATE_CARD_MASTER: baseUrl + "/master/rate-card/create",
  MODIFY_RATE_CARD_MASTER: baseUrl + "/master/rate-card/modify",
  ALL_RATE_CARD_DATA: baseUrl + "/master/rate-card/allData",
};
